import { connect, useDispatch } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { AuthRoutePropsType } from './ProtectedRoute';
import { useEffect } from 'react';
import { useDocumentTitle } from '../utils/useDocumentTitle';

function RedirectRoute({ component: Component, path = '',title, description, ...rest }: AuthRoutePropsType) {
  const dispatch = useDispatch();
  useDocumentTitle(title,description)

  useEffect(() => {
    if (!rest.isLoggedIn) {
      // If token is not there, we are clearing the session storage data
      dispatch({ type: 'CLEAR_SESSION_DATA' });
    }
  }, [rest.isLoggedIn])

  return (
    <Route
      {...rest}
      render={(props) =>
        rest.isLoggedIn ? (
          <Redirect to="/" from={props.location.pathname} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

export default connect(({ auth }: RootStateType) => {
  return { isLoggedIn: !!auth.token };
}, {})(RedirectRoute);
